<!--
 * @Description  : 购票须知中的抢票候补说明
-->
<template>
  <view>
    <explain class="explain1" explainValue="{{explainValue1}}"></explain>
    <explain class="explain1" explainValue="{{explainValue2}}"></explain>
    <explain class="explain1" explainValue="{{explainValue3}}">
      <common-table
        slot="tabrefund"
        tableValue="{{tableValue1}}"
      />
    </explain>
    <explain class="explain1" explainValue="{{explainValue4}}"></explain>
    <explain class="explain1" explainValue="{{explainValue5}}"></explain>
    <view wx:style="{{ {background:'#fff', borderRadius:'8px', overflow:'hidden'} }}">
      <notes notesList="{{notesList1}}"></notes>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'

  createComponent({
    data: {
      explainValue1: {
        title: '候补购票是什么？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '遇到车票售完的情况，可登记购买车次及乘车人相关信息，支付预购票资金后，系统如有退票、余票，将自动为您购票。'
                }
              ]
            }
          ],
        ],
      },
      explainValue2: {
        title: '双通道抢票是什么？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '在监控车次余票的同时，若该车次支持候补购票，将第一时间为您自动候补排队购票，候补购票+余票监控双通道同时抢，抢票成功率更高！'
                }
              ]
            }
          ],
        ],
      },
      explainValue3: {
        title: '如何使用双通道抢票？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '根据铁路局规定，使用候补购票功能有以下要求：'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 手机app完成人证核验或开通12306畅行会员'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 需预付所选车次、座席的最高票价，出票成功后，将根据实际出票价格退还您差价，出票失败，全额退款！'
                }
              ]
            }
          ]
        ]
      },
      tableValue1: [
        [{
          text: '普通候补',
          subText: '单通道候补',
        },{
          text: '双通道抢票',
          subText: '候补+监控同时抢',
        }],
        [{
          text: '开抢时间：\n未开售不可购票，不可候补',
        },{
          text: '开抢时间：\n开售自动秒杀抢票，秒杀失败自动候补',
        }],
        [{
          text: '多条件抢：\n单日最多选2个车次',
        },{
          text: '多条件抢：\n支持5个日期，单日最多15个车次同时抢',
        }],
        [{
          text: '选择范围：\n支持5个日期，单日最多15个车次同时抢',
        },{
          text: '选择范围：\n可直接抢到发车前25分钟',
        }],
        [{
          text: '成功率：\n仅候补购票通道',
        },{
          text: '成功率：\n候补+余票双通道同时抢票，成功率更高',
        }],
        [{
          text: '候补机会：\n需人工查看可否候补',
        },{
          text: '候补机会：\n实时扫描候补席位，有席位自动候补',
        }]
      ],
      explainValue4: {
        title: '怎样开始双通道抢票？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666; margin-bottom:12px; display:inline-block;'
              },
              children: [
                {
                  type: 'text',
                  text: '1. 进入抢票订单填写页'
                }
              ]
            },
            {
              name: 'img',
              attrs: {
                src: 'https://ut-static.udache.com/webx/sfc/Xc5zm9qIbBB-pSslCBzjx_clipboard_image_1698229816904.png',
                width: '298px',
                height: '126px'
              },
              children: []
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color: #666666; margin-bottom:12px; display:inline-block;'
              },
              children: [
                {
                  type: 'text',
                  text: '2. 找到双通道抢票-候补通道，点击「去开启」'
                }
              ]
            },
            {
              name: 'img',
              attrs: {
                src: 'https://ut-static.udache.com/webx/sfc/p7J7NeMYlMkBEj9aAy7PS_clipboard_image_1698229838046.png',
                width: '298px',
                height: '138px'
              },
              children: []
            }
          ],
        ],
      },
      explainValue5: {
        title: '候补相关规则？',
        listText: [
          [
            {
              name: 'span',
              attrs: {
                style: 'color:#666666; display:flex;'
              },
              children: [
                {
                  name: 'span',
                  attrs: {
                    style: 'color:#666666; display:inline-flex; width:17px; flex:none;'
                  },
                  children: [{
                    type: 'text',
                    text: '1.'
                  }]
                },
                {
                  name: 'span',
                  children: [{
                    type: 'text',
                    text: '铁路局规定：使用候补购票必须预付车票款。收款时将按照订单中最高座席票价收取'
                  }]
                },
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color:#666666; display:inline-block; margin-left:17px;'
              },
              children: [
                {
                  type: 'text',
                  text: '候补成功后，若实际出票金额低于预收票款，自动原路退回差价。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color:#666666; display:inline-block; margin-left:17px;'
              },
              children: [
                {
                  type: 'text',
                  text: '候补失败，全额退回预收票款。'
                }
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color:#666666; display:flex;'
              },
              children: [
                {
                  name: 'span',
                  attrs: {
                    style: 'color:#666666; display:inline-flex; width:17px; flex:none;'
                  },
                  children: [{
                    type: 'text',
                    text: '2.'
                  }]
                },
                {
                  name: 'span',
                  children: [{
                    type: 'text',
                    text: '每位用户仅可提交2个候补订单，每个候补订单最多5位乘客，订单限制条件如下：'
                  }]
                },
              ]
            }
          ],
          [
            {
              name: 'span',
              attrs: {
                style: 'color:#666666; display:inline-block; margin-left:17px;'
              },
              children: [
                {
                  type: 'text',
                  text: '1个订单可添加发到站相同（可以是同城的不同车站）的2个相邻乘车日期，每个乘车日期可添加5个不同“车次+座席”的组合需求。'
                }
              ]
            }
          ]
        ]
      },
      notesList1: [
        {
          title: '解答及说明',
          list: [
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    name: 'p',
                    attrs: {
                      style: 'margin-bottom:6px;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: 'Q：在滴滴选择了10个车次，候补成功2个车次，其他车次是否还在抢票？'
                      }
                    ]
                  },
                  {
                    name: 'p',
                    children: [
                      {
                        type: 'text',
                        text: 'A：在滴滴候补成功后，剩余8车次将使用余票监控通道继续抢票，有票自动出！'
                      }
                    ]
                  },
                ]
              },
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    name: 'p',
                    attrs: {
                      style: 'margin-bottom:6px;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: 'Q：什么时间可以提交候补订单？'
                      }
                    ]
                  },
                  {
                    name: 'p',
                    attrs: {
                      style: 'margin-bottom:6px;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: 'A：候补订单的提交时间与12306网站运营时间一致；候补订单的兑现时间为24小时兑现：候补终止时间不晚于开车前2小时。'
                      }
                    ]
                  },
                  {
                    name: 'p',
                    children: [
                      {
                        type: 'text',
                        text: '不满足候补提交时间，仍可使用滴滴余票监控，进行捡漏抢票！'
                      }
                    ]
                  },
                ]
              },
            ],
            [
              {
                name: 'span',
                attrs: {
                  style: 'color: #666666;'
                },
                children: [
                  {
                    name: 'p',
                    attrs: {
                      style: 'margin-bottom:6px;'
                    },
                    children: [
                      {
                        type: 'text',
                        text: 'Q：已购车次车票与候补订单车次行程冲突怎么办？'
                      }
                    ]
                  },
                  {
                    name: 'p',
                    children: [
                      {
                        type: 'text',
                        text: 'A：如乘车人其他已购车次的车票与候补车次行程冲突，系统仍将为您继续候补抢票需求，候补成功车票的退改签规则按既有规则办理'
                      }
                    ]
                  },
                ]
              },
            ],
          ]
        }
      ],
    },
  })
</script>

<style scoped lang="stylus">
  .explain1
    margin-bottom 12px
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      explain: '@/components/ticket-guide/explain',
      notes: '@/components/ticket-guide/notes',
      'common-table': './common-table'
    }
  }
</script>